import moment from "moment";
import Vue from 'vue';
import ReportsService from '@/services/ReportsService';
import MasterService from '@/services/MasterService';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';
import { authenticationService } from "@/services/AuthenticationService";
import { movieWeekEnd } from "@/helper/collection";

function initialState() {
    return {
        HourlySPHObject: {
            fromDate: new Date(),
            toDate: new Date(),
            startTime: null,
            endTime: null,
            cinema_id: null,
            cinema_name: null,
        }
    };
};
const state = initialState();

const mutations = {
    SET_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.HourlySPHObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.HourlySPHObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'MasterMovie':
                state.dropDownObject.movie_id = payload['selectedItem'] ? payload.selectedItem.movie_id : null;
                state.dropDownObject.movie_title = payload['selectedItem'] ? payload.selectedItem.movie_title : null;
                break;
            default: console.log('Hourly SPH Report :( Sorry, we are enable to set value.');
        }
    },
    ON_RESET_HOURLY_SPA_REPORT_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    SET_HOURLY_SPA_REPORT_DATES: (state, payload) => {
        payload['name'] ? state.HourlySPHObject[payload.name] = payload['event'] ? payload.event : null : '';
    },
};

const actions = {
    onResetHourlySPHStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_HOURLY_SPA_REPORT_STORE_STATE');
    },
    onHourlySPHReportDateHandler: async ({ dispatch, commit, state }, payload) => {
        commit('SET_HOURLY_SPA_REPORT_DATES', payload)
    },
    onHourlySPHReportsReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DROP_DOWN_VALUES', payload);
    },

}

const getters = {
    getHourlySPHReportsReportsSelectedCinema: state => state.HourlySPHObject.cinema_name,
    getHourlySPHReportFromDate: state => state.HourlySPHObject.fromDate,
    getHourlySPHReportStartTime: state => state.HourlySPHObject.startTime,
    getHourlySPHReportEndTime: state => state.HourlySPHObject.endTime,
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/HourlySPHReport.js